import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { ContractorHeadCount, InterviewsStatus, vendorInfo, strategicData } from '@interfaces/vendor-profile.model';
import { VendorEmployeeCount } from '@interfaces/vendor-management-model';
import { GlobalErrorService } from './global-error.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private baseUrl = environment.apiUrl;
  private cache: { [key: string]: any } = {};
  constructor(private http: HttpClient, private globalError: GlobalErrorService) {}

    getContractorHeadCount(employeeId: string, month: string, year: string, vendorName: string): Observable<{ data: ContractorHeadCount[] }> {
        const encodedVendorName = encodeURIComponent(vendorName);
        const url = `${this.baseUrl}/hiring/vendors-employee-count?employeeId=${employeeId}&month=${month}&year=${year}&vendorName=${encodedVendorName}`;
    return this.http.get<{ data: ContractorHeadCount[] }>(url).pipe(
      catchError((error) => {
        this.globalError.logError(error);
        throw error;
      })
    );
  }

  getContractorHeadCountByVendor(employeeId: string, month: string, year: string, vendorId: string): Observable<{ data: ContractorHeadCount[] }> {
    const url = `${this.baseUrl}/hiring/contractors-headcount?employeeId=${employeeId}&month=${month}&year=${year}&vendorId=${vendorId}`;
    return this.http.get<{ data: ContractorHeadCount[] }>(url).pipe(
      catchError((error) => {
        this.globalError.logError(error);
        throw error;
      })
    );
  }

  getVendorEmployeeCount(employeeId: string, month: string, year: string): Observable<{ data: VendorEmployeeCount[] }> {
    const url = `${this.baseUrl}/hiring/vendors-employee-count?employeeId=${employeeId}&month=${month}&year=${year}`;
    return this.http.get<{ data: VendorEmployeeCount[] }>(url).pipe(
      catchError((error) => {
        this.globalError.logError(error);
        throw error;
      })
    );
  }

  getVendorData(vendorId: string): Observable<{ status: string; reason: string; data: vendorInfo[] }> {
    const url = `${this.baseUrl}/hiring/vendor-information?vendorId=${vendorId}`;
    return this.http.get<{ status: string; reason: string; data: vendorInfo[] }>(url).pipe(
      catchError((error) => {
        this.globalError.logError(error);
        throw error;
      })
    );
  }

  getInterviewStatus(vendorId: string, month: string, year: string): Observable<{ data: InterviewsStatus }> {
    const url = `${this.baseUrl}/hiring/candidate-interview-status?vendorId=${vendorId}&month=${month}&year=${year}`;
    return this.http.get<{ data: InterviewsStatus }>(url).pipe(
      catchError((error) => {
        this.globalError.logError(error);
        throw error;
      })
    );
  }

  getContractors<T>(employeeId: string, month: number, year: number): Observable<{ status: string; reason: string; data: T[] }> {
    const url = `${this.baseUrl}/hiring/contractors-list?employeeId=${employeeId}&month=${month}&year=${year}`;
    return this.http.get<{ status: string; reason: string; data: T[] }>(url).pipe(
      catchError((error) => {
        this.globalError.logError(error);
        throw error;
      })
    );
  }

  getStrategicPartnership(employeeId:string, year: number, quarter: string,  vendorId: string | null): Observable<{ data: strategicData[] }> {
    const url = `${this.baseUrl}/hiring/quarterly-feedback/strategic-partnership?employeeId=${employeeId}&year=${year}&quarter=${quarter}&vendorId=${vendorId}`;
    return this.http.get<{ data: strategicData[] }>(url).pipe(
      catchError((error) => {
        alert(error);
        throw error;
      })
    );
  }


}
